import createAction from 'helpers/createAction';

import { STORE_UNREAD_BELL_ALERTS } from 'actionTypes/bellAlerts';

export const storeUnreadBellAlerts = createAction(STORE_UNREAD_BELL_ALERTS);
